module.exports = __webpack_public_path__ + "media/images/front/treatment_support/mv_appeal_refine_sp-6c1b6991535f12a60ee50bcb1300a5bd.png";